'use client';

import classNames from 'classnames';
import Image from 'next/image';
import { useParams, usePathname } from 'next/navigation';
import React, { FC } from 'react';

// import { BADALYANS_AI_ROUTE } from '@/app/[lang]/Router/routes';
// import Link from '@/components/core/Link';
import { useTranslation } from '@/hooks/useTranslations';
import new18 from '@/public/assets/Images/18-new.png';
import gambleAware from '@/public/assets/Images/gambleaware.png';
import gamblingComission from '@/public/assets/Images/gambling-comission-logo.png';
// import img1 from '@/public/assets/Images/image1.png';
// import Logo from '@/public/assets/Images/Logo.png';
import mGa from '@/public/assets/Images/mga_scaled4.png';

import JoinOurTeam from './components/JoinOurTeam';

export const socialIcons = [
  {
    logo: 'bc-i-facebook',
    name: 'facebook',
    link: 'https://facebook.com/PopOkGamingOfficial',
  },
  {
    logo: 'bc-i-instagram',
    name: 'instagram',
    link: 'https://instagram.com/popokgamingofficial',
  },
  {
    logo: 'bc-i-linkedin',
    name: 'linkedin',
    link: 'https://www.linkedin.com/company/popok-gaming/',
  },
  {
    logo: 'bc-i-Subtract',
    name: 'youtube',
    link: 'https://youtube.com/@PopOK_Gaming',
  },
  { logo: 'bc-i-twitter', name: 'x', link: 'https://x.com/popok_gaming' },
];

const Footer: FC = () => {
  const params = useParams();
  const pathname = usePathname();
  const { t } = useTranslation();

  return (
    <div
      className={classNames('footer', {
        rico: pathname === `/${params.lang}/rico-series` || pathname === '/rico-series',
      })}
    >
      <div className={'NewsletterAndPartnerWrp'}>
        <div className="bigContent">
          <JoinOurTeam />
        </div>
      </div>
      <div
        className={`footerHolder ${pathname.includes('poly') ? 'polyPage' : ''} ${pathname.includes('avi') ? 'aviPage' : ''}`}
      >
        <div className="bigContent">
          {/*<div className="footerTop">*/}
          {/*  <Link href={`/${params.lang}`} className="footerLogo" aria-label="footer-logo">*/}
          {/*    <Image src={Logo} alt="" />*/}
          {/*  </Link>*/}
          {/*  <Link*/}
          {/*    // href={BADALYANS_AI_ROUTE.getPath(params.lang as string)}*/}
          {/*    className="footerTopRight"*/}
          {/*  >*/}
          {/*    <div className="footerTopRightImg">*/}
          {/*      <Image src={img1} alt="" />*/}
          {/*    </div>*/}
          {/*    <p className="footerTopRightTitle">Vigen Badalyan’s ai</p>*/}
          {/*  </Link>*/}
          {/*</div>*/}
          <div className="footerContent">
            <div className="footerContentLeft">
              <div className="footerLeftContentImgWrp">
                <a
                  target="_blank"
                  href="https://www.gambleaware.org"
                  className="footerLeftContentImgItem begamble"
                  aria-label="gambleaware"
                >
                  <Image src={gambleAware} alt="" />
                </a>
                <a
                  target="_blank"
                  href="https://authorisation.mga.org.mt/verification.aspx?company=448d2c4f-22f1-4b3d-93d7-a543968b1dde"
                  className="footerLeftContentImgItem mga"
                  aria-label="mga"
                >
                  <Image src={mGa} alt="" />
                </a>
                <a
                  target="_blank"
                  href="https://authorisation.mga.org.mt/verification.aspx?company=448d2c4f-22f1-4b3d-93d7-a543968b1dde"
                  className="footerLeftContentImgItem commission"
                  aria-label="gambling commission"
                >
                  <Image src={gamblingComission} alt="" />
                </a>
                <div className="footerLeftContentImgItem new18">
                  <Image src={new18} alt="" />
                </div>
              </div>
              <div className="footerSocialBlock">
                <p className="footerSocialBlockTxt">{t('Footer-Socias-Button')}</p>
                <div className="footerSocialInner">
                  {socialIcons.map((social, index) => (
                    <a
                      key={index}
                      target="_blank"
                      href={social.link}
                      rel="noopener noreferrer"
                      aria-label={social.name}
                      className="footer-social-link"
                    >
                      <i className={`${social.logo} footerSocialIcon`} />
                    </a>
                  ))}
                </div>
              </div>
              {/* <div className="footerPrivacyBlock">
                <a href="#" className="footerPrivacyTxt">
                  Privacy Policy
                </a>
                <a href="#" className="footerPrivacyTxt">
                  Cookie Policy
                </a>
                <a href="#" className="footerPrivacyTxt">
                  Terms & Conditions
                </a>
              </div> */}
            </div>
            <div className="footerContentRight">
              <p className="footerContentRightInfoTxt">{t('Footer - Description')}</p>
              <p className="footerContentRightInfoTxt">{t('Footer - All rights reserved ')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
